export const es = {
    title: `Olvidé mi contraseña`,
    description: `Ingresa tu correo electrónico y te enviaremos instrucciones para restablecerla`,
    success: `Revisa tu correo electrónico para las instrucciones de restablecimiento`,
    sendInstructions: `Enviar instrucciones de restablecimiento`,
    failure: `No se pudo enviar el correo de restablecimiento`,
};
//# sourceMappingURL=es.js.map